import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let modules = {}
let requireModule = require.context('.', true, /\.js$/)

requireModule.keys().forEach(fileName => {
  if (fileName === './index.js') return

  let path = fileName.replace(/(\.\/|\.js)/g, '')
  let moduleName = path.split('/')

  modules[moduleName] = requireModule(fileName).default
})

// Create a new store
const store = new Vuex.Store({
  modules
})

export default store
